import type { ActivityEvent } from '@/types/dashboard';
import { Badge } from '@/components/ui/badge';
import { fmt } from '@/lib/format';

interface Props {
  events: ActivityEvent[];
}

export function ActivityFeed({ events }: Props) {
  if (events.length === 0) {
    return (
      <div className="py-8 text-center text-sm text-muted-foreground">No recent activity.</div>
    );
  }

  return (
    <ol className="space-y-3">
      {events.map((e) => (
        <li key={e.id} className="flex gap-3">
          <div className="relative mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted text-[10px] font-semibold uppercase text-muted-foreground ring-1 ring-border">
            {(e.actor ?? 'SY').slice(0, 2)}
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
              <Badge variant="muted" className="text-[10px] uppercase">
                {e.module}
              </Badge>
              <span className="text-sm text-foreground">{e.summary}</span>
            </div>
            <div className="mt-0.5 text-[11px] text-muted-foreground">
              {e.actor ?? 'System'} · {fmt.relative(e.occurredAt)}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
